// extracted by mini-css-extract-plugin
module.exports = {"CheckboxLabel__label":"CheckboxButton_CheckboxLabel__label__2B58t","CheckboxLabel__root":"CheckboxButton_CheckboxLabel__root__1jWp4","small":"CheckboxButton_small__2vWDn"};